import {registerGlobalInitFunc} from '../modules/observer.ts';
import {GET} from '../modules/fetch.ts';

// the card comes from SeaTable, so it loads after the page instead of slowing it down
export function initRepoPrismPullCard(): void {
  registerGlobalInitFunc('initRepoPrismPullCard', async (el: HTMLElement) => {
    const resp = await GET(el.getAttribute('data-url')!);
    if (resp.status !== 200) return; // 204: no card, or card links are off
    el.innerHTML = await resp.text();
  });
}
